import React from "react";
import { useNavigate } from "react-router-dom";

export default function Unauthorized() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: "70vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "12px",
          border: "0.5px solid #e0e0e0",
          padding: "2rem",
          width: "340px",
          textAlign: "center",
        }}
      >
        <div
          style={{
            width: 48,
            height: 48,
            borderRadius: "50%",
            background: "#fcebeb",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 16px",
          }}
        >
          <i className="ti ti-lock" style={{ fontSize: 24, color: "#a32d2d" }} />
        </div>
        <p style={{ fontWeight: 500, fontSize: 18, margin: "0 0 6px" }}>
          You don't have access
        </p>
        <p style={{ fontSize: 14, color: "#666", margin: "0 0 24px" }}>
          You don't have permission to view this page. Contact your admin if you think this is a mistake.
        </p>
        <button
          onClick={() => navigate("/dashboard")}
          style={{
            width: "100%",
            padding: "10px 0",
            border: "0.5px solid #ccc",
            borderRadius: "8px",
            background: "#fff",
            cursor: "pointer",
          }}
        >
          Go to dashboard
        </button>
      </div>
    </div>
  );
}